import { gql } from 'apollo-boost';
import { useMutation } from '../';

export const newIndicator = gql`
  mutation newIndicator(
    $name: String!,
    $definition: String!,
    $stageId: Int!,
    $guidance: String!,
    $tagList: String!,
    $benchmarkType: String,
    $measurementTypeId: Int,
    $servicesList: String,
    $customizable: Boolean
  ) {
  newIndicator(
    name: $name,
    definition: $definition,
    stageId: $stageId,
    guidance: $guidance,
    tagList: $tagList,
    benchmarkType: $benchmarkType,
    measurementTypeId: $measurementTypeId,
    servicesList: $servicesList,
    customizable: $customizable
  ) {
      success
      id
    }
  }
`;

export function useNewIndicator() {
  const { data, isLoading, mutate } = useMutation();
  const run = (variables, onFinish) => {
    mutate(newIndicator, variables, (response) => {
      if (typeof onFinish === 'function') {
        onFinish(response.newIndicator.id);
      }
    });
  };
  return { data, isLoading, run };
}
